import script from "./InlineAddressEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./InlineAddressEditor.vue?vue&type=script&setup=true&lang=ts"

import "./InlineAddressEditor.vue?vue&type=style&index=0&id=c52628f4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c52628f4"]])

export default __exports__